const buildAttachmentBundleDomId = (locator: string) =>
  `attachment-bundle-${encodeURIComponent(locator)}`

const buildFormFieldDomId = (locator: string) =>
  `form-field-${encodeURIComponent(locator)}`

export { buildAttachmentBundleDomId, buildFormFieldDomId }
